// extracted by mini-css-extract-plugin
module.exports = {"container":"hero-module--container--2vKeB","name":"hero-module--name--2hIIi"};